import type { FamilyMember } from '@/components/order/OrderTypes'

export function hasParentData(parent: FamilyMember): boolean {
  return !!(
    parent.info.firstName ||
    parent.info.lastName ||
    parent.info.dateOfBirth ||
    parent.info.medicalRecordNumber ||
    parent.info.email ||
    parent.info.phone ||
    parent.info.phenotypes.length > 0
  )
}

/** Comparator demographics/contact/HPO/clinical notes — not sample type alone (parent must explicitly choose sample type). */
export function familyMemberHasComparatorSummaryData(member: FamilyMember): boolean {
  const info = member.info
  return Boolean(
    info.firstName?.trim() ||
    info.lastName?.trim() ||
    info.dateOfBirth?.trim() ||
    info.medicalRecordNumber?.trim() ||
    info.email?.trim() ||
    info.phone?.trim() ||
    (info.phenotypes?.length ?? 0) > 0 ||
    (info.clinicalNotes?.trim() ?? '') !== ''
  )
}
